import React, { type FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'

import { BroadCastBadge } from '../../../badges/BroadCastBadge/BroadCastBadge'
import { NoBroadCastBadge } from '../../../badges/NoBroadCastBadge/NoBroadCastBadge'
import { ReplyBadge } from '../../../badges/ReplyBadge/ReplyBadge'
import { PlanedBadge } from '../../../badges/PlanedBadge/PlanedBadge'
import { HighlightBadge } from '../../../badges/HighlighBadge/HighlightBadge'
import { AddressBadge } from '../../../badges/AddressBadge/AddressBadge'

import classes from './FooterInfo.module.scss'
import { ChannelBadge } from '../../../badges/ChannelBadge/ChannelBadge'

type FooterInfoProps = {
  game: FeedData
}
export const FooterInfo: FC<FooterInfoProps> = ({ game }) => {
  const hasHighlight = game.hasHighlight
  const isReply = game.isReplay
  const hasLivestream = game.hasLivestream
  const isInFuture = new Date((+game.publishedAt || 0) * 1000) > new Date()
  const hasPlanedBandge = isInFuture && hasLivestream

  const channelName = game.channelName

  if (
    !game.location.name &&
    !isInFuture &&
    !isReply &&
    !hasLivestream &&
    !hasHighlight &&
    !channelName
  ) {
    return null
  }

  return (
    <div className={classes.Container}>
      {game.location.name ? (
        <AddressBadge address={game.location.name} />
      ) : (
        <ChannelBadge channelName={channelName} />
      )}
      <div className={classes.Badges}>
        {hasPlanedBandge ? (
          <PlanedBadge />
        ) : hasLivestream ? (
          <BroadCastBadge />
        ) : (
          <NoBroadCastBadge />
        )}
        {isReply && <ReplyBadge />}
        {hasHighlight && <HighlightBadge />}
      </div>
    </div>
  )
}
